import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../../src/common/Constant";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import CleanupConfirmationModal from "../../../../src/components/Modal/CleanupConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";
import * as XLSX from "xlsx";
import { Noimage } from "../../../common/imagePath";
import moment from "moment";
import ChangePasswordModal from "../../../components/Modal/ChangePassword";
import DeleteIcon from "@mui/icons-material/Delete";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-employee";
let PERMISSION_EDIT = "/manage-employee/:id";
let PERMISSION_DELETE = "delete-employees";
let PERMISSION_MANAGE_DELETED_EMPLOYEES = "/deleted-employees";
let PERMISSION_EXCEL_EXPORT = "excelexport-employee";
let PERMISSION_CLEANUP_OLD_EMPLOYEES = "cleanup-old-employees";
let PERMISSION_PERMISSION_TEMPLATE = "/manage-permissions";

let PERMISSION_CUSTOM_FIELD_CONFIGURATION =
  "/custom-field-employee-configuration";

const Employees = () => {
  let selectData = [];
  let pathforpdf = "";
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");
  const [employeeid, setEmployeeId] = useState(0);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [PasswordModalOpen, setPasswordModalOpen] = useState(false);

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;
    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.employeesBaseUrl
        }/employees?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res76", res);
        setData(res.data.ResponseData);
        setEmployeeId(res.data.ResponseData[0].Id);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  console.log("data85", data);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };
  // const formatDate = (string) => {
  //   return moment(string).format("YYYY-DD-MM");
  // };

  // const toogleSelection = (event) => {
  //   setToggleCleared(!toggleCleared);
  // };

  // const handleDeletePopup = (pID) => {
  //   console.log("pID: ", pID);
  //   const deleteRequestParam = {
  //     employeeids: pID || selectedDataDelete,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.Id).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      id: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     // for get detlais form id
  //     setSelectedRows(e.selectedRows.map((x) => x.Id));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Id);
  //     const selectedEmpolyeeCheckboxIDs =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     const selectedDataDelete =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setSelectedDataDelete(selectedDataDelete);
  //     setselectedEmployeeCheckbox(selectedEmpolyeeCheckboxIDs);
  //     const datasplitforpath = selectedEmpolyeeCheckboxIDs?.split(",");
  //     pathforpdf = datasplitforpath?.join("~");
  //     setselectedEmployeeCheckpathforpdf(pathforpdf);
  //     console.log("Datasasasa", pathforpdf);

  //     // get emails of selectdids
  //     setSelectedRows(e.selectedRows.map((x) => x.Email));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Email);
  //     const selectedEmployeeCheckboxEmails =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedEmployeeCheckEmails(selectedEmployeeCheckboxEmails);
  //     console.log(selectedEmployeeCheckboxEmails);
  //   }
  // };

  // const contextActions = useMemo(() => {
  //   // For handle pdf
  //   const handlepdf = () => {
  //     console.log("selectedEmployeeCheckboxs: ", selectedEmployeeCheckboxs);
  //     axios
  //       .get(
  //         `${config.employeesBaseUrl}/employees/employeedetailforlabel?id=${selectedEmployeeCheckboxs}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         const doc = new jsPDF();

  //         let position = 0;
  //         for (let i = 0; i < res.data.ResponseData.length; i++) {
  //           console.log(res.data.ResponseData.length);
  //           position = position + 10;
  //           doc.setFontSize(10);

  //           doc.text(
  //             `Firstname: ${res.data.ResponseData[i].Firstname}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(
  //             `Lastname: ${res.data.ResponseData[i].Lastname}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
  //           position = position + 10;
  //           doc.text(
  //             `Phonenumber: ${res.data.ResponseData[i].Phonenumber}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(
  //             `Address1: ${res.data.ResponseData[i].Address1}`,
  //             10,
  //             position
  //           );
  //           console.log(res.data.ResponseData);

  //           position = position + 10;

  //           if ((i + 1) % 4 == 0) {
  //             doc.addPage();
  //             position = 0;
  //           } else if (i == res.data.ResponseData.length - 1) {
  //           }
  //         }
  //         //   doc.deletePage(Last);
  //         doc.save(`Employee_mailing_label${Date.now()}.pdf`);
  //         setState({ data: res.data.ResponseData });
  //       });
  //   };

  //   return (
  //     <>
  //       {/* E-Mail */}
  //       <div className="row px-2 ">
  //         <div className="col-12 align-self-center">
  //           {checkUserPermission(PERMISSION_EMAIL_EMPLOYEES) ? (
  //             <a href={"mailto:" + selectedEmployeeCheckEmails}>
  //               <button type="button" className="btn btn-dark btn-sm ">
  //                 <i className="fa fa-envelope fa-sm" /> E-mail
  //               </button>
  //             </a>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>

  //       {/* Mailing Labels */}
  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* <a href={"/mailing_labels/" + selectedCustomerCheckpathforpdf}> */}
  //           {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
  //             <button
  //               type="button"
  //               className="btn btn-dark btn-sm"
  //               title="MailingLabels"
  //               onClick={handlepdf}
  //             >
  //               <i className="fa fa-envelope-square fa-sm" /> Mailing-Labels
  //             </button>
  //           ) : (
  //             ""
  //           )}

  //           {/* </a> */}
  //         </div>
  //       </div>

  //       {/* Delete */}
  //       {checkUserPermission(PERMISSION_DELETE) ? (
  //         <button
  //           type="button"
  //           className="btn btn-danger btn-sm pull-left"
  //           data-bs-toggle="modal"
  //           data-bs-target="#DeleteConfirmationModal"
  //           onClick={() => handleDeletePopup()}
  //         >
  //           <i className="fa fa-trash fa-sm" /> Delete Selected
  //         </button>
  //       ) : (
  //         ""
  //       )}

  //       {/* Clear Selection */}
  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* <a href={"/mailing_labels/" + selectedCustomerCheckpathforpdf}> */}
  //           <button
  //             type="button"
  //             className="btn btn-dark btn-sm"
  //             title="Clear Selection"
  //             onClick={(event) => toogleSelection(event)}
  //           >
  //             <i className="fa fa-envelope-square fa-sm" /> Clear Selection
  //           </button>
  //           {/* </a> */}
  //         </div>
  //       </div>
  //     </>
  //   );
  // }, [data, selectedRows, toggleCleared]);

  useEffect(() => {
    handleListData(1, perPageSize, searchtext, sortingId, sortingDirection);
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  // Table Data
  // const columns = [
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <div class="btn-group-sm" role="group" >
  //         {checkUserPermission(PERMISSION_EDIT) && (
  //           <>
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/manage-employee/${row.Id}`}
  //               style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //             >
  //               Edit
  //             </Link>
  //           </>
  //         )}

  //         {(checkUserPermission(PERMISSION_DELETE) || checkUserPermission(PERMISSION_CHANGEPASSWORD) ) && (
  //           <>
  //             <button
  //               type="button"
  //               className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //               data-bs-toggle="dropdown"
  //               aria-haspopup="true"
  //               aria-expanded="false"
  //               style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //             >
  //             </button>
  //             <div className="dropdown-menu">
  //               {checkUserPermission(PERMISSION_CHANGEPASSWORD) && (
  //                 <li>
  //                   <Link
  //                     className=" dropdown-item confirm-text ml-1"
  //                     to="#"
  //                     title="Delete"
  //                     data-bs-toggle="modal"
  //                     data-bs-target="#ChangePasswordModal"
  //                   // onClick={() => handleDeletePopup(row.Id)}
  //                   >
  //                     <i
  //                       className="fa fa-key"
  //                       data-bs-toggle="tooltip"
  //                       title="Change Password"
  //                     ></i>Change Password
  //                   </Link>
  //                 </li>
  //               )}
  //               {/* <Link
  //             className="confirm-text ml-1"
  //             to="#"
  //             title="Delete"
  //             data-bs-toggle="modal"
  //             data-bs-target="#DeleteConfirmationModal"
  //             // onClick={() => handleDeletePopup(row.Id)}
  //           >
  //             <i
  //               className="fa fa-eye text-warning fa-2x"
  //               data-bs-toggle="tooltip"
  //               title="View"
  //             ></i>
  //           </Link> */}
  //               {checkUserPermission(PERMISSION_DELETE) ? (
  //                 <li>
  //                   <Link
  //                     className="dropdown-item confirm-text ml-1"
  //                     to="#"
  //                     title="Delete"
  //                     data-bs-toggle="modal"
  //                     data-bs-target="#DeleteConfirmationModal"
  //                     onClick={() => handleDeletePopup(row.Id)}
  //                   >
  //                     <i
  //                       className="fa fa-trash"
  //                       data-bs-toggle="tooltip"
  //                       title="Delete"
  //                     ></i>
  //                     Delete
  //                   </Link>
  //                 </li>
  //               ) : (
  //                 ""
  //               )}
  //             </div>
  //           </>
  //         )}
  //       </div >
  //     )
  //   },
  //   // {
  //   //   name: "Sr.No",
  //   //   selector: (row, index) => index + 1,
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Name",
  //     // selector: (row) => row.Firstname + " " + row.Lastname,
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Firstname + " " + row.Lastname}>
  //         {row.Firstname + " " + row.Lastname}
  //       </p>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "Username",
  //     // selector: "Username",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Username}>
  //         {row.Username}
  //       </p>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "E-Mail",
  //     // selector: "Email",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Email}>
  //         {row.Email}
  //       </p>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "Phone Number",
  //     selector: "Phonenumber",
  //     sortable: true,
  //   },
  //   {
  //     name: "Profile",
  //     selector: "Image",
  //     sortable: true,
  //     cell: (row) => (
  //       <>
  //         <a href={row.Image} target="_blank">
  //           <img
  //             src={row.Image}
  //             alt="Profile Image"
  //             style={{
  //               maxWidth: "30px",
  //               maxHeight: "70px",
  //               margin: "5px",
  //             }}
  //             onError={(e) => {
  //               e.target.onerror = null;
  //               // style={{
  //               //   maxWidth: "70px",
  //               //   maxHeight: "70px",
  //               //   margin: "5px",
  //               // }}
  //               e.target.src = Noimage;
  //             }}
  //           ></img>
  //         </a>
  //       </>
  //     ),
  //   },
  //   // {
  //   //   name: "Birth Date",
  //   //   selector: "Birthday",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Hire Date",
  //   //   selector: "Hiredate",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Comments",
  //   //   selector: "Comments",
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Employee Number",
  //     selector: "Employeenumber",
  //     sortable: true,
  //   },
  //   // {
  //   //   name: "Address 1",
  //   //   selector: "Address1",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Address 2",
  //   //   selector: "Address2",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "City",
  //   //   selector: "City",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "State",
  //   //   selector: "State",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Zip",
  //   //   selector: "Zip",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Country",
  //   //   selector: "Country",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Force Password Change",
  //   //   selector: "Forcepasswordchange",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Always Require Password",
  //   //   selector: "Alwaysrequirepassword",
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Inactive",
  //     selector: "Inactive",
  //     sortable: true,
  //     width: "100px"
  //   },
  //   // {
  //   //   name: "Reason Inactive",
  //   //   selector: "Reasoninactive",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Language",
  //   //   selector: "Language",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Commission Default Rate",
  //   //   selector: "Commissiondefaultrate",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Commission Percent Type",
  //   //   selector: "Commissionpercenttype",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Hourly Pay Rate",
  //   //   selector: "Hourlypayrate",
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Not Required To Clockin",
  //   //   selector: "Notrequiredtoclockin",
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Created On",
  //     selector: (row) => formatDate(row.CreatedDate),
  //     sortable: true,
  //   },
  //   // {
  //   //   name: "Action",
  //   //   width: "10%",
  //   //   cell: (row) => (
  //   //     <>
  //   //       {checkUserPermission(PERMISSION_EDIT) ? (
  //   //         <Link to={`/manage-employee/${row.Id}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}
  //   //       <Link
  //   //         className="confirm-text ml-1"
  //   //         to="#"
  //   //         title="Delete"
  //   //         data-bs-toggle="modal"
  //   //         data-bs-target="#ChangePasswordModal"
  //   //       // onClick={() => handleDeletePopup(row.Id)}
  //   //       >
  //   //         <i
  //   //           className="fa fa-key text-warning fa-2x"
  //   //           data-bs-toggle="tooltip"
  //   //           title="Change Password"
  //   //         ></i>
  //   //       </Link>
  //   //       {/* <Link
  //   //           className="confirm-text ml-1"
  //   //           to="#"
  //   //           title="Delete"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#DeleteConfirmationModal"
  //   //           // onClick={() => handleDeletePopup(row.Id)}
  //   //         >
  //   //           <i
  //   //             className="fa fa-eye text-warning fa-2x"
  //   //             data-bs-toggle="tooltip"
  //   //             title="View"
  //   //           ></i>
  //   //         </Link> */}
  //   //       {checkUserPermission(PERMISSION_DELETE) ? (
  //   //         <Link
  //   //           className="confirm-text ml-1"
  //   //           to="#"
  //   //           title="Delete"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#DeleteConfirmationModal"
  //   //           onClick={() => handleDeletePopup(row.Id)}
  //   //         >
  //   //           <i
  //   //             className="fa fa-trash text-red fa-2x"
  //   //             data-bs-toggle="tooltip"
  //   //             title="Delete"
  //   //           ></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}
  //   //     </>
  //   //   ),
  //   //   ignoreRowClick: true,
  //   //   allowOverflow: true,
  //   //   button: true,
  //   // },
  // ];

  const columns = useMemo(() => [
    {
      header: "Name",
      accessorKey: "Name",
      Cell: ({ row }) => row.original.Firstname + " " + row.original.Lastname,
    },
    {
      header: "Username",
      accessorKey: "Username",
    },
    {
      header: "E-Mail",
      accessorKey: "Email",
    },
    {
      header: "Phone Number",
      accessorKey: "Phonenumber",
    },
    {
      header: "Inactive",
      accessorKey: "Inactive",
    },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      Cell:({row})=>moment(row.original.CreatedDate).format('DD-MM-YYYY HH:mm:ss')
    },
  ]);
 
  const handleExcelExport = () => {
    console.log("hello");
    setLoading(true);
    axios
      .post(
        `${config.employeesBaseUrl}/employees/excelexport`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        const data =
          res.data.ResponseData.length > 0 ? res.data.ResponseData : [];

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `employees_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Employees</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Employees List</li>
              </ul>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
            <div>
              {/* dynamically hide or show columns */}
              <div className="btn-group pull-right ms-2 dropdown">
                {/* <button
                  type="button"
                  className="btn btn-sm btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button> */}
                {/* <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div> */}
              </div>
              {/* <button onClick={() => setHideDirector(!hideDirector)} className="btn btn-outline-primary pull-right ms-2"><i className="fa fa-cog"></i></button> */}
              <div className="btn-group pull-right ms-2 ">
                <button type="button" className="btn btn-outline-dark d-none">
                  More
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                  {/* <span className="sr-only">Toggle Dropdown</span> */}
                </button>
                <div className="dropdown-menu">
                  <li>
                    {checkUserPermission(PERMISSION_PERMISSION_TEMPLATE) ? (
                      <Link class="dropdown-item" to="/manage-permissions">
                        Permission Template
                      </Link>
                    ) : (
                      ""
                    )}
                    <li>
                      {checkUserPermission(
                        PERMISSION_CUSTOM_FIELD_CONFIGURATION
                      ) ? (
                        <Link
                          class="dropdown-item"
                          to="/custom-field-employee-configuration"
                        >
                          Employee Custom Fields
                        </Link>
                      ) : (
                        ""
                      )}
                    </li>
                    <li>
                      {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                        <Link class="dropdown-item" onClick={handleExcelExport}>
                          Excel Export
                        </Link>
                      ) : (
                        ""
                      )}
                    </li>
                    <li>
                      {checkUserPermission(PERMISSION_CLEANUP_OLD_EMPLOYEES) ? (
                        <Link
                          to="#"
                          title="Cleanup old Employees"
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#CleanupConfirmationModal"
                        >
                          Cleanup old Employees
                        </Link>
                      ) : (
                        ""
                      )}
                      <li>
                        {checkUserPermission(
                          PERMISSION_MANAGE_DELETED_EMPLOYEES
                        ) ? (
                          <Link class="dropdown-item" to="/deleted-employees">
                            Manage Deleted Employee
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                    </li>
                  </li>
                </div>
              </div>
              {/* <div className="btn-group pull-right ms-2">
                                <button type="button" className="btn btn-outline-dark d-none">
                                    More
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-dark dropdown-toggle me-1"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    style={{ borderRadius: "5px" }}
                                >
                                    More &nbsp;
                                    {/* <span className="sr-only">Toggle Dropdown</span> 
                                </button>
                                <div className="dropdown-menu">
                                    <li>
                                        <Link class="dropdown-item" to="/manage-permissions">
                                            Permission Template
                                        </Link>
                                    </li>
                                </div>
                            </div> */}
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="/manage-employee"
                  // className="btn btn-added pull-right"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Employee
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="row flex-row-reverse mt-2">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
          </div>

          {/* Customer list */}
          {/* <div className="card"> */}
          {/* <div className="card-body"> */}
          {/* <div className="table-responsive">
                <DataTable
                  title="Employees List"
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  dense
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  selectableRows
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div> */}

          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            enableRowActions
            // enableEditing
            // editingMode="row"
            // onEditingRowSave={handleSaveRow}
            renderRowActionMenuItems={({ row }) => [
              <MenuItem
                key="edit"
                onClick={() => navigate(`/manage-employee/${row.original.Id}`)}
              >
                Edit
              </MenuItem>,
              <MenuItem
                key="edit"
                data-bs-toggle="modal"
                data-bs-target="#ChangePasswordModal"
                onClick={() => setPasswordModalOpen(true)}
              >
                change password
              </MenuItem>,
              <MenuItem
                className="confirm-text"
                to="#"
                // key="delete"
                title="Delete"
                data-bs-toggle="modal"
                data-bs-target="#DeleteConfirmationModal"
                onClick={() => handleDeletePopup(row.original.Id, "", "")}
              >
                {/* <DeleteIcon /> */}
                Delete
              </MenuItem>,
              row.original.Attachements ? (
                <a
                  className="dropdown-item confirm-text"
                  href={row.original.Attachements}
                  target="_blank"
                  title="Attachment"
                >
                  <MenuItem title="Attachment">Attachments</MenuItem>
                </a>
              ) : (
                ""
              ),
            ]}
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            // manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              // columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  size="small"
                  disabled={
                    !table.getIsSomeRowsSelected() &&
                    !table.getIsAllRowsSelected()
                  }
                  //only export selected rows
                  onClick={() =>
                    handleDeletePopup(
                      "",
                      table.getSelectedRowModel().rows,
                      "multipleRowInactive"
                    )
                  }
                  // startIcon={<FileDownloadIcon />}
                  startIcon={<DeleteIcon />}
                  variant="contained"
                >
                  Delete Selected
                </Button>
              </Box>
            )}
          />
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.employeesBaseUrl}/employees/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      <ChangePasswordModal
        employeeid={employeeid}
        open={PasswordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        field="Employees"
      />

      {/* Cleanup old suppliers */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.employeesBaseUrl}/employees/deletepermanantely`}
      />
    </>
  );
};

export default Employees;
